import { QuestionType } from "../../../api/main/models/codeOnly/QuestionType";
import { DeleteQuestionBase } from "../DeleteQuestionBase";

/**
 * Delete a question.
 */
export const DeleteQuestion = () => (<DeleteQuestionBase defaultQuestionType={QuestionType.MultipleChoiceVideo} />);
